import Input from "@/components/Input";
import Dropdown from "@/components/Dropdown";
import Button from "@/components/Button";
import Table from "@/components/Table";
import HeaderColumn from "@/components/Table/table-header/HeaderColumn";
import Toogle from "@/components/Toogle";
import BodyImageWithInfoColumn from "@/components/Table/table-body/BodyImageWithInfoColumn";
import NO_IMG from "@/assets/icons/no-image-square.svg";
import BodyColumn from "@/components/Table/table-body/BodyColumn";
import Badge from "@/components/Badge";
import Pagination from "@/components/Pagination";
import getNewsInteractor from "@/@core/interactor/news/get-news.intearctor";
import { useEffect, useState } from "react";
import { News } from "@/@core/entity/news.entity";
import { stringToDate } from "@/utils/date";
import "./style.scss";

const NewsPage = () => {
  const [news, setNews] = useState<News[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);

  useEffect(() => {
    getNews(activePage);
  }, []);

  const getNews = async (page: number) => {
    try {
      const repsonse = await getNewsInteractor({
        limit: 5,
        page,
      });

      const {
        data: { data, pagination },
      } = repsonse;

      setNews(data);
      if (pagination) {
        setActivePage(pagination.current_page);
        setTotalPage(pagination.last_page);
      }
    } catch (error: any) {
      setNews([]);
      setActivePage(1);
      setTotalPage(1);
    }
  };

  const onChangePagination = (e: any) => {
    setActivePage(e);
    getNews(e);
  };

  return (
    <div className="news-page-wrapper">
      <div className="header-page">
        <h1>News</h1>
        <span className="desc">Manage news in app & website.</span>
      </div>

      {/* <div className="table-control-section">
        <div>
          <label>Search for source</label>
          <Input
            style={{ width: "360px" }}
            value={""}
            withIcon
            type="search"
            placeholder="Search"
            onChange={() => {}}
            onKeyDown={() => {}}
          />
        </div>
        <div>
          <label>Status</label>
          <Dropdown
            value={{
              label: "All",
              value: "all",
            }}
            options={[
              {
                label: "All",
                value: "all",
              },
            ]}
            onChange={() => {}}
            optionType="text-option"
            width="192px"
          />
        </div>
        <div>
          <label>Category</label>
          <Dropdown
            value={{
              label: "All",
              value: "all",
            }}
            options={[
              {
                label: "All",
                value: "all",
              },
            ]}
            onChange={() => {}}
            optionType="text-option"
            width="192px"
          />
        </div>
        <div className="btn-wrapper">
          <Button
            onClick={() => {}}
            label="Reset Filter"
            type="secondary"
            size="md"
            // disabled={!search && category.value === "all" && status.value === 0}
          />
        </div>
      </div> */}

      <div className="table-section">
        <Table>
          <thead>
            <tr>
              <HeaderColumn label="Source" alignLabel="text-left" />
              {/* <HeaderColumn label="" alignLabel="text-left" /> */}
              <HeaderColumn label="Crawl" alignLabel="text-center" />
              {/* <HeaderColumn label="Categories" alignLabel="text-center" /> */}
              <HeaderColumn label="Status" alignLabel="text-center" />
              <HeaderColumn label="Created at" alignLabel="text-center" />
              <HeaderColumn label="Last Sync" alignLabel="text-center" />
            </tr>
          </thead>
          <tbody>
            {news.map((item, index) => (
              <tr key={index}>
                {/* <td width="50px">
                <div className="text-with-toogle-column">
                  <Toogle checked={true} onChange={() => {}} />
                </div>
              </td> */}
                <BodyImageWithInfoColumn
                  width="400px"
                  imgSrc={item.thumbnail}
                  roundedImg="20px"
                  textName={item.source}
                  defaultImg={NO_IMG}
                  textDesc={item.url}
                />
                <BodyColumn
                  width="100px"
                  label={`${item.read_time} mins`}
                  alignLabel="text-center"
                />
                {/* <td width="100px">
                <div className="item-center">
                  <Badge
                    label="Sepak Bola"
                    labelColor="#344054"
                    backgroundColor="#F2F4F7"
                  />
                </div>
              </td> */}
                <td width="100px">
                  <div className="item-center">
                    <Badge
                      label={item.status === 1 ? "Inactive" : "Active"}
                      labelColor={item.status === 1 ? "#344054" : "#067647"}
                      backgroundColor={
                        item.status === 1 ? "#F2F4F7" : "#ECFDF3"
                      }
                    />
                  </div>
                </td>
                <BodyColumn
                  width="200px"
                  label={stringToDate(item.created_at, "dd month yyyy")}
                  alignLabel="text-center"
                />
                <BodyColumn
                  width="200px"
                  label={stringToDate(item.updated_at, "dd month yyyy")}
                  alignLabel="text-center"
                />
              </tr>
            ))}
          </tbody>
        </Table>

        <Pagination
          activePage={activePage}
          totalPage={totalPage}
          onChange={onChangePagination}
        />
      </div>
    </div>
  );
};

export default NewsPage;
